import { z } from "zod";

import { buildNamespace } from "@smart/itops-types-basic";

import { system } from "./base";
import { FormNS } from "./form";
import { UserNS } from "./user";

export const FormVersionNS = buildNamespace({
  system,
  entity: "FormVersion",
} as const);

export const formVersionKindValue = ["auto", "published"] as const;
export type FormVersionKind = (typeof formVersionKindValue)[number];
export const formVersionKindSchema = z.enum(formVersionKindValue);

export const formVersionStatusValue = [
  "creating",
  "created",
  "failed",
] as const;
export type FormVersionStatus = (typeof formVersionStatusValue)[number];
export const formVersionStatusSchema = z.enum(formVersionStatusValue);

export const FormVersionSchema = z.object({
  uri: FormVersionNS.schema,
  operationId: z.string(),

  formUri: FormNS.schema,
  snapshotHash: z.string().optional(),

  createdAt: z.string(),
  updatedAt: z.string(),

  updatedBy: UserNS.schema.optional(),

  status: formVersionStatusSchema.optional(),

  // Auto daily snapshots vs an explicit publishing snapshots.
  versionKind: formVersionKindSchema.optional(),
  publishedAt: z.string().optional(),
  publishedBy: UserNS.schema.optional(),
  publishNote: z.string().optional(),
});

export type FormVersion = z.infer<typeof FormVersionSchema>;

export const canApplyFormVersion = (
  version: Pick<FormVersion, "status" | "snapshotHash">,
) =>
  version.status !== "creating" &&
  version.status !== "failed" &&
  !!version.snapshotHash;
